module.exports = __webpack_public_path__ + "img/back_closure_length.10a17cbd.png";